import { useState } from "react";
import { animated, useSpring } from "react-spring";
import { screens } from "../../constants/constants";
import { useWindowSize } from "../../hooks/useWindowSize";
import { OnCurtainStart } from "../../types/types";

export const Hamburger = ({
  onCurtainStart,
  gridArea,
}: {
  onCurtainStart: OnCurtainStart;
  gridArea?: string;
}) => {
  const { w, h, horizontal } = useWindowSize();
  return (
    <div
      id=""
      className=""
      {...{
        style: {
          gridArea,
          placeSelf: "start end",
          height: h(3),
          width: horizontal ? w(2) : w(6),
          display: "grid",
          placeItems: "center",
          zIndex: 99,
          cursor: "pointer",
        },
      }}
      onClick={() => {
        onCurtainStart({ curtainTo: screens.menu });
      }}
    >
      {[...Array(3)].map((item, index) => (
        <div
          key={index}
          id=""
          className=""
          {...{
            style: {
              width: "100%",
              height: "2px",
              // height: h(0.2),
              background: "white",
            },
          }}
        />
      ))}
    </div>
  );
};

export const HamburgerLegacy = ({ onCurtainStart }) => {
  const { currentDisplay } = { ...useWindowSize() };
  const [openMenu, openMenuSet] = useState(false);
  const [expandMenu, expandMenuSet] = useState(false);

  const dimensions = {
    width: {
      desktop: 900,
      tabletHorizontal: 520,
      tabletVertical: 520,
      mobileHorizontal: 520,
      mobileVertical: 320,
    },
    height: {
      desktop: 400,
      tabletHorizontal: 200,
      tabletVertical: 360,
      mobileHorizontal: 180,
      mobileVertical: 420,
    },
    hamburgerBar: {
      width: 18,
      height: 13.75,
      yPosition1: 3,
      yPosition2: 8,
      yPosition3: 13,
      strokeWidth: 1.5,
    },
  };

  const { viewBox } = useSpring({
    from: {
      viewBox: !expandMenu
        ? `0 0 ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.height}`
        : `0 0 ${dimensions.width[currentDisplay]} ${dimensions.height[currentDisplay]}`,
    },
    to: {
      viewBox: !expandMenu
        ? `0 0 ${dimensions.width[currentDisplay]} ${dimensions.height[currentDisplay]}`
        : `0 0 ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.height}`,
    },
  });

  const { blur } = useSpring({
    from: {
      blur: openMenu ? `blur(0px)` : `blur(4px)`,
    },
    to: {
      blur: openMenu ? `blur(4px)` : `blur(0px)`,
    },
  });

  const { hamburgerBar1 } = useSpring({
    from: {
      hamburgerBar1: openMenu
        ? `
                    M ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.yPosition1}
                    h 0 0
                    `
        : `
                    M ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.yPosition1}
                    h 0 0
                    `,
    },
    to: {
      hamburgerBar1: openMenu
        ? `
                M ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.yPosition1}
                h -${dimensions.width[currentDisplay]} 0
                `
        : `
                M ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.yPosition1}
                h -${dimensions.hamburgerBar.width} 0
                `,
    },
    onRest: () => {
      expandMenuSet(!expandMenu);
    },
  });

  const { hamburgerBar2 } = useSpring({
    from: {
      hamburgerBar2: openMenu
        ? `
                        M ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.yPosition2} 
                        h -${dimensions.hamburgerBar.width} 0
                        `
        : `
                        M ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.yPosition2} 
                        h 0 0
                    `,
    },
    to: {
      hamburgerBar2: openMenu
        ? `
            M ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.yPosition2}  
            h 0 0
            `
        : `
                M ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.yPosition2} 
                h -${dimensions.hamburgerBar.width} 0
                `,
    },
  });

  const { hamburgerBar3 } = useSpring({
    from: {
      hamburgerBar3: openMenu
        ? `
                    M ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.yPosition3}
                    h 0 0
                    `
        : `
                    M ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.yPosition3}
                    h 0 0
                    `,
    },
    to: {
      hamburgerBar3: openMenu
        ? !expandMenu
          ? `
                        M ${dimensions.width[currentDisplay]} ${dimensions.height[currentDisplay]}
                        h -${dimensions.width[currentDisplay]} 0
                        `
          : `
                        M ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.yPosition3}
                        h -${dimensions.width[currentDisplay]} 0
                        `
        : `
                M ${dimensions.width[currentDisplay]} ${dimensions.hamburgerBar.yPosition3}
                h -${dimensions.hamburgerBar.width} 0
                `,
    },
  });

  return (
    <>
      <div
        {...{
          id: "click-helper",
          onClick: () => {
            openMenuSet(!openMenu);
          },
          style: {
            position: "absolute",
            right: 0,
            top: 0,
            height: dimensions.hamburgerBar.width,
            width: dimensions.hamburgerBar.width,
            zIndex: 99999,
            // backgroundColor: 'orange',
          },
        }}
      ></div>
      <animated.div
        {...{
          style: {
            width: "100%",
            position: "absolute",
            top: 0,
            backdropFilter: blur,
            overflow: "hidden",
            zIndex: 9999,
          },
        }}
      >
        <animated.svg
          {...{
            viewBox: viewBox,
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          }}
        >
          <animated.path
            {...{
              id: "hamburgerBar1",
              style: {
                stroke: "white",
                strokeWidth: dimensions.hamburgerBar.strokeWidth,
              },
              d: hamburgerBar1,
            }}
          />
          <animated.path
            {...{
              id: "hamburgerBar2",
              style: {
                stroke: "white",
                strokeWidth: dimensions.hamburgerBar.strokeWidth,
              },
              d: hamburgerBar2,
            }}
          />
          <animated.path
            {...{
              id: "hamburgerBar3",
              style: {
                stroke: "white",
                strokeWidth: dimensions.hamburgerBar.strokeWidth,
              },
              d: hamburgerBar3,
            }}
          />
        </animated.svg>
      </animated.div>
    </>
  );
};
